import React from "react"
import { Switch, Route } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import { ROLES_URL, ROLES_ID_URL } from "src/constants/routeNames"
import Roles from "src/containers/Roles"

export default (
  <Route path={ROLES_URL}>
    <BaseLayout title="Роли">
      <Switch>
        <Route path={ROLES_URL} exact component={Roles} />
        <Route path={ROLES_ID_URL} component={Roles} />
      </Switch>
    </BaseLayout>
  </Route>
)
